import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
}, (error) => Promise.reject(error));

api.interceptors.response.use((response) => response, (error) => {
  if (error.response?.status === 401) { localStorage.removeItem('token'); window.location.href = '/login'; }
  return Promise.reject(error);
});

export default api;

export const authAPI = { login: (email, password) => api.post('/auth/login', { email, password }), me: () => api.get('/auth/me') };
export const devicesAPI = { getAll: (params) => api.get('/devices', { params }), getById: (id) => api.get(`/devices/${id}`), update: (id, data) => api.patch(`/device/${id}`, data), delete: (id) => api.delete(`/devices/${id}`) };
export const usersAPI = { getAll: () => api.get('/users'), create: (data) => api.post('/users', data), delete: (id) => api.delete(`/users/${id}`) };
export const tenantsAPI = { getAll: () => api.get('/tenants'), create: (data) => api.post('/tenants', data), delete: (id) => api.delete(`/tenants/${id}`) };
export const statsAPI = { get: () => api.get('/stats') };
export const searchAPI = { search: (q) => api.get('/search', { params: { q } }) };
